import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Loader from '../Loader/Loader.js'
import {Row,Col,Icon} from 'antd'
import styles from './Page.less'

export default class PageDetail extends Component {
  render() {
    const { className, children, loading = false, inner = false,detailVisiable,detailTitle,onClose,direction } = this.props
    const loadingStyle = {
      height: 'calc(100vh - 184px)',
      overflow: 'hidden',
    }

    const leftStyle = {
        overflow: 'hidden',
        borderRightWidth: '1px',
        borderRightColor: "#eee",
        borderRightStyle: "solid",
    }

    const titleStyle = {
        height: '40px',
        display: "flex",
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignContent: 'center',
        fontSize: '20px',
        borderBottomWidth: '1px',
        borderBottomColor: "#eee",
        borderBottomStyle: "solid",
        marginBottom: '10px',
    }

    console.log(this.props.children)

    let visiable = false;
    if (detailVisiable != undefined){
        visiable = detailVisiable;
    }

    let _direction = 'row'
    if (direction != undefined){
        _direction = direction
    }

    if (_direction == 'column'){
        return (
            <div
              style={loading ? loadingStyle : {background:"white"}}
            >
              {loading ? <Loader spinning /> : ''}
              {visiable ? <Row>
                      <div className={classnames(className, {
                      ["contentInner"]: inner,
                      })} >
                          <div style={titleStyle}>
                              <div>
                              {detailTitle}
                              </div>
                              <div>
                              <Icon onClick={onClose} type="close" />
                              </div>
                          </div>
                          {this.props.children[1]}
                      </div>
              </Row> : <div
              className={classnames(className, {
                  ["contentInner"]: inner,
              })}
              >{this.props.children[0]}</div> }
              
            </div>
            
      
          )
    }

    return (
      <div
        style={loading ? loadingStyle : {background:"white"}}
      >
        {loading ? <Loader spinning /> : ''}
        {visiable ? <Row>
            <Col style={leftStyle} span={16}>
                <div className={classnames(className, {
                ["contentInner"]: inner,
                })} >
                    {this.props.children[0]}
                </div>
            </Col>
            <Col span={8} >
                <div className={classnames(className, {
                ["contentInner"]: inner,
                })} >
                    <div style={titleStyle}>
                        <div>
                        {detailTitle}
                        </div>
                        <div>
                        <Icon onClick={onClose} type="close" />
                        </div>
                    </div>
                    {this.props.children[1]}
                </div>
            </Col>
        </Row> : <div
        className={classnames(className, {
            ["contentInner"]: inner,
        })}
        >{this.props.children[0]}</div> }
        
      </div>
      

    )
  }
}

PageDetail.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  loading: PropTypes.bool,
  inner: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Page/PageDetail.js